import { useParams } from "react-router";
import { BatchSearchMatches } from "@/app/(app)/batch/[batchId]/search/[searchId]/_components/batch-search-matches";
import NotFoundPage from "../_errors/NotFoundPage";

export default function BatchSearchMatchesPage() {
  const { batchId, searchId } = useParams();
  if (!batchId || !searchId) return <NotFoundPage />;
  return <BatchSearchMatches batchId={batchId} searchId={searchId} />;
}
